/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Sso_X15_DeniedInputs */

const en_signin_sso_x15_denied = /** @type {(inputs: Signin_Sso_X15_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Single sign-on was cancelled at your company's sign-in page. Try again when you are ready.`)
};

/** @type {(inputs: Signin_Sso_X15_DeniedInputs) => LocalizedString} */
const ar_signin_sso_x15_denied = en_signin_sso_x15_denied;

/** @type {(inputs: Signin_Sso_X15_DeniedInputs) => LocalizedString} */
const he_signin_sso_x15_denied = en_signin_sso_x15_denied;

/** @type {(inputs: Signin_Sso_X15_DeniedInputs) => LocalizedString} */
const ur_signin_sso_x15_denied = en_signin_sso_x15_denied;

/** @type {(inputs: Signin_Sso_X15_DeniedInputs) => LocalizedString} */
const es_signin_sso_x15_denied = en_signin_sso_x15_denied;

/** @type {(inputs: Signin_Sso_X15_DeniedInputs) => LocalizedString} */
const fr_signin_sso_x15_denied = en_signin_sso_x15_denied;

/** @type {(inputs: Signin_Sso_X15_DeniedInputs) => LocalizedString} */
const de_signin_sso_x15_denied = en_signin_sso_x15_denied;

/** @type {(inputs: Signin_Sso_X15_DeniedInputs) => LocalizedString} */
const pt_signin_sso_x15_denied = en_signin_sso_x15_denied;

/** @type {(inputs: Signin_Sso_X15_DeniedInputs) => LocalizedString} */
const hi_signin_sso_x15_denied = en_signin_sso_x15_denied;

/** @type {(inputs: Signin_Sso_X15_DeniedInputs) => LocalizedString} */
const bn_signin_sso_x15_denied = en_signin_sso_x15_denied;

/**
* | output |
* | --- |
* | "Single sign-on was cancelled at your company's sign-in page. Try again when you are ready." |
*
* @param {Signin_Sso_X15_DeniedInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_sso_x15_denied = /** @type {((inputs?: Signin_Sso_X15_DeniedInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Sso_X15_DeniedInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_sso_x15_denied(inputs)
	if (locale === "he") return he_signin_sso_x15_denied(inputs)
	if (locale === "ur") return ur_signin_sso_x15_denied(inputs)
	if (locale === "es") return es_signin_sso_x15_denied(inputs)
	if (locale === "fr") return fr_signin_sso_x15_denied(inputs)
	if (locale === "de") return de_signin_sso_x15_denied(inputs)
	if (locale === "pt") return pt_signin_sso_x15_denied(inputs)
	if (locale === "hi") return hi_signin_sso_x15_denied(inputs)
	if (locale === "bn") return bn_signin_sso_x15_denied(inputs)
	return /** @type {LocalizedString} */ ("Single sign-on was cancelled at your company's sign-in page. Try again when you are ready.")
});